/*
  SyncNudgeCard — shown to anonymous users (only when feature_accounts is on)
  on Hub + Settings, inviting them to create an account so their data syncs
  across devices. Hides itself once the user is signed in.
*/
import { useState } from "react";
import { Link } from "react-router-dom";
import { Cloud, ArrowRight } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import FeatureGate from "./FeatureGate";
import AuthModal from "./AuthModal";

function Inner() {
  const { user, loading } = useAuth();
  const [open, setOpen] = useState(false);
  if (loading || user) return null;
  return (
    <>
      <div
        data-testid="sync-nudge-card"
        className="card-tactile rounded-2xl p-4 sm:p-5 flex items-start sm:items-center gap-4 flex-col sm:flex-row"
        style={{ background: "var(--primary-soft)" }}
      >
        <div className="shrink-0 h-10 w-10 rounded-xl flex items-center justify-center"
             style={{ background: "var(--primary)", color: "white" }}>
          <Cloud className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display tracking-tight text-lg leading-snug"
               style={{ color: "var(--primary-ink)" }}>
            Sync across your devices
          </div>
          <div className="text-sm mt-0.5" style={{ color: "var(--text-muted)" }}>
            Create a free account so your prescriptions, lists, and notes follow you everywhere.
          </div>
        </div>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => setOpen(true)}
            data-testid="sync-nudge-signin"
            className="h-9 px-3 rounded-lg text-sm font-semibold border"
            style={{ borderColor: "var(--border-subtle)", color: "var(--text-main)" }}
          >Sign in</button>
          <Link
            to="/register"
            data-testid="sync-nudge-register"
            className="h-9 px-4 rounded-lg text-sm font-semibold text-white inline-flex items-center gap-1.5"
            style={{ background: "var(--primary)" }}
          >
            Create account <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
      <AuthModal open={open} onOpenChange={setOpen} initialMode="login" />
    </>
  );
}

export default function SyncNudgeCard() {
  return (
    <FeatureGate flag="feature_accounts">
      <Inner />
    </FeatureGate>
  );
}
